import React from "react";
import PropTypes from "prop-types";
import { MetricsElement } from "react-metrics";

import '../css/radio.less';

export class RadioGroup extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            selectedValue: this.props.controlValue || this.props.defaultValue
        }
    }

    componentDidUpdate(_, prevState) {
        if(prevState.selectedValue !== this.state.selectedValue && this.props.onChange) {
            this.props.onChange(this.state.selectedValue);
        }
    }

    changeValue(value) {
        if(this.props.controlValue && this.props.onChange) {
            this.props.onChange(value);
        } else {
            this.setState({selectedValue: value});
        }
    }

    render() {
        const value = this.props.controlValue || this.state.selectedValue;
        return (
        <div className='radio-group'>
            {React.Children.map(this.props.children, (child, i) => {
                if(child.type === RadioOption) {
                    const isSelected = child.props.value === value;
                    const handleClick = () => this.changeValue(child.props.value);
                    return React.cloneElement(child, {isSelected, handleClick});
                } else {
                    return child;
                }
            })}
        </div>
        );
    }
}

RadioGroup.propTypes = {
    defaultValue: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
      ]),
    onChange: PropTypes.func
  };


export class RadioOption extends React.Component {

    render() {

        const { handleClick, isSelected, children, ...rest } = this.props;

        return (
            <MetricsElement
                element="div"
                className={`radio-option${isSelected? ' selected' : ''}`} 
                onClick={handleClick}
                {...rest}
            >
                <RadioIcon isSelected={isSelected}/>
                <div className='radio-option-content'>{children}</div>
            </MetricsElement>
        );
    }
}

RadioOption.propTypes = {
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
}


export class RadioIcon extends React.Component {

    render() {
        return (
            <div className='radio-icon'></div>
        );
    }
}
